import { Component, Input, OnInit } from '@angular/core';
import { FijosParadasModel } from 'src/app/shared/models/servicios/fijosParadas.model';

@Component({
  selector: 'app-timeline-fijo',
  templateUrl: './timeline-fijo.component.html',
  styleUrls: ['./timeline-fijo.component.css']
})
export class TimelineFijoComponent implements OnInit {

  @Input()
  paradas : FijosParadasModel[] = [];

  constructor() { }

  ngOnInit(): void {
    console.log(this.paradas);
    
  }

  get onlyParadas(){
    return this.paradas?.filter(x => x.esparada);
  }

}
